import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { isMobileDevice } from 'src/utils/util';

let isMobile = isMobileDevice();

export const MoreNavLinkStyle = styled.div`
    margin: 0rem;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    cursor: pointer;
    background: ${(props) =>
        isMobile
            ? props.isBackground
                ? '#DCDCDC!important'
                : 'transparent'
            : 'transparent'};
    &:hover,
    :active {
        border: ${isMobile ? 'none !important' : ''};
        border-left: 5px solid #1010eb;
    }

    & a {
        width: 100%;
        border: 1px solid transparent;
        color: #140f4b;
        text-decoration: none;
        padding: 0.5rem;
        margin-left: ${isMobile ? '65px' : '25px'};
        text-align: left;
    }
    ${media.smalDevice`           
    background:${(props) =>
        props.isBackground ? '#DCDCDC!important' : 'transparent'};
        & a {
        margin-left: 135px;       
        }                
        &:hover,
        :active {
            border: none;      
            background:#DCDCDC!important;              
        }
    `}

    ${media.smalDevice`           
    background:${(props) =>
        props.isBackground ? '#DCDCDC!important' : 'transparent'};
        & a {
        margin-left: 135px;       
        }                
        &:hover,
        :active {
            border: none;      
            background:#DCDCDC!important;              
        }
    `}
    ${media.mobileDevice`        
        flex-direction: row;
        border: none;
        background:${(props) =>
            props.isBackground ? '#DCDCDC!important' : 'transparent'};
        & a {
        margin-left: 65px;       
        } 

        &:hover,
        :active {
            border: none;
            background:#DCDCDC!important; 
        }
    `}
`;
